/**
 * Product cards (event delegation, works for cards added later too):
 * - hover (mouse only): fade to a random other photo of the product
 * - thumbnails: swap the card's main photo
 * - "+" button: open the quick-add pop-up (product.quick template, no redirect)
 */
(() => {
  if (window.BrisatoCards) return;
  window.BrisatoCards = true;

  /* ---------- #51: rails below the fold load their photos only when near ---------- */
  const fill = (scope) =>
    scope.querySelectorAll('img[data-defer]').forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-defer');
    });
  const watchDeferred = () => {
    const scopes = document.querySelectorAll('[data-defer-scope]');
    if (!scopes.length) return;
    if (!('IntersectionObserver' in window)) return scopes.forEach(fill);
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          fill(entry.target);
          io.unobserve(entry.target);
        }),
      { rootMargin: '600px 0px' }
    );
    scopes.forEach((scope) => io.observe(scope));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDeferred);
  else watchDeferred();

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const imagesOf = (media) => (media.dataset.images ? media.dataset.images.split('|') : []);

  /* ---------- Hover: random other photo, fade ---------- */
  document.addEventListener(
    'pointerenter',
    (event) => {
      if (!canHover.matches || !(event.target instanceof Element)) return;
      const media = event.target.closest('[data-card-media]');
      if (!media || event.target !== media) return;
      const images = imagesOf(media);
      const hover = media.querySelector('[data-card-hover]');
      if (images.length < 2 || !hover) return;
      const current = Number(media.dataset.current || 0);
      let next = current;
      while (next === current) next = Math.floor(Math.random() * images.length);
      const show = () => media.classList.add('is-hovering');
      if (hover.getAttribute('src') === images[next] && hover.complete) {
        show();
      } else {
        hover.onload = () => media.matches(':hover') && show();
        hover.src = images[next];
      }
    },
    true
  );

  document.addEventListener(
    'pointerleave',
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.matches('[data-card-media]')) event.target.classList.remove('is-hovering');
    },
    true
  );

  /* ---------- Clicks: thumbnails and quick add ---------- */
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-card-thumb]');
    if (thumb) {
      const card = thumb.closest('[data-card]');
      const media = card.querySelector('[data-card-media]');
      const main = card.querySelector('[data-card-main]');
      const index = Number(thumb.dataset.cardThumb);
      const images = imagesOf(media);
      if (main && images[index]) {
        main.removeAttribute('srcset');
        main.src = images[index];
        media.dataset.current = index;
        media.classList.remove('is-hovering');
      }
      card.querySelectorAll('[data-card-thumb]').forEach((b) => b.toggleAttribute('aria-current', b === thumb));
      return;
    }

    const quick = event.target.closest('[data-quick-add]');
    if (quick) {
      event.preventDefault();
      openQuickAdd(quick.dataset.quickAdd, quick);
    }
  });

  /* ---------- Quick-add pop-up ---------- */
  const dialog = () => document.querySelector('[data-quick-add-dialog]');

  const ensureAssets = (dlg) => {
    if (!document.querySelector('link[data-pp-css]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = dlg.dataset.css;
      link.dataset.ppCss = '';
      document.head.append(link);
    }
    if (customElements.get('product-page')) return Promise.resolve();
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = dlg.dataset.js;
      script.onload = resolve;
      document.head.append(script);
    });
  };

  async function openQuickAdd(url, opener) {
    const dlg = dialog();
    if (!dlg) {
      window.location.href = url.replace('?view=quick', '');
      return;
    }
    const body = dlg.querySelector('[data-quick-add-body]');
    opener.setAttribute('aria-busy', 'true');
    // Open at once with the loader (#38), instead of nothing happening until it loads
    body.innerHTML = '<div class="qa-loading"></div>';
    const stopLoader = window.brisatoLoader ? window.brisatoLoader(body.firstElementChild) : () => {};
    if (!dlg.open) dlg.showModal();
    try {
      const [html] = await Promise.all([fetch(url).then((r) => r.text()), ensureAssets(dlg)]);
      stopLoader();
      body.innerHTML = html;
    } catch (_) {
      stopLoader();
      dlg.close();
      window.location.href = url.replace('?view=quick', '');
    } finally {
      opener.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const dlg = dialog();
    if (!dlg || !dlg.open) return;
    if (event.target === dlg || event.target.closest('[data-quick-add-close]')) dlg.close();
  });

  // After a successful add from the pop-up, close it (the cart drawer opens itself)
  document.addEventListener('cart:item-added', () => {
    const dlg = dialog();
    if (dlg && dlg.open) dlg.close();
  });
})();
